import { render } from "./AgreementComponent.vue?vue&type=template&id=be1c1d00"
import script from "./AgreementComponent.vue?vue&type=script&lang=js"
export * from "./AgreementComponent.vue?vue&type=script&lang=js"

import "./AgreementComponent.vue?vue&type=style&index=0&id=be1c1d00&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__